module.exports = __webpack_public_path__ + "img/emoji_007.992313d2.png";